import React from 'react'
import { Container } from 'components'

export default ({ MenuContentElement }) => (
  <Container>{MenuContentElement}</Container>
)
